import ProfileLoader from "../../../../../components/ABOProfile/ProfileLoader/ProfileLoader";
import { useGetABOProfileQuery } from "../../../../../services/AboProfile/AboProfileAPI";
import { useAppSelector } from "../../../../../store";
import ApplicantItem from "../../../../../components/ABOProfile/ApplicantComponents/ApplicantItem/ApplicantItem";
import "./ABOProfilePrimaryApplicantCard.scss";
import { cardActionClickTrack } from "../../../../../common/tealium/ABOProfile/Profile/ApplicantCardTrack";

const ABOProfilePrimaryApplicantCard = () => {
  // Get Login ABO
  const affAbo = useAppSelector((state) => state.profile.affAbo);
  const isFromEdLos = useAppSelector((state) => state.profile.isFromEdLos);
  const [aff = "", abo = ""] = affAbo.split("-");
  const boot = useAppSelector(({ boot }) => boot);
  const profileInfo = boot?.configuration?.profile?.aboInfo || {};

  const { isFetching, data } = useGetABOProfileQuery({
    aff,
    abo,
    ...(isFromEdLos ? { includePlatinumAndAbove: true } : {}),
  });

  const applicantTrackOnclick = (event?: string) => {
    cardActionClickTrack(event, true);
  };

  if (isFetching === false && data?.aboInfo && data.partyInfo) {
    const { aboInfo, partyInfo } = data;

    const partyAvaliable = partyInfo && partyInfo.length > 0;
    const primaryParty = partyInfo.find(({ isPrimary }) => isPrimary === true) || partyInfo[0];

    const party = {
      ...primaryParty,
      partyId: "",
    };

    if (partyAvaliable === true) {
      return (
        <div className="abo-applicant-card">
          <ApplicantItem
            aboInfo={aboInfo}
            partyInfo={party}
            isExpandable={false}
            applicantTrackOnclick={applicantTrackOnclick}
            profileInfo={profileInfo}
          />
        </div>
      );
    }

    return <></>;
  }

  return <ProfileLoader row={1} applicant={true} isFetching={isFetching} />;
};

export default ABOProfilePrimaryApplicantCard;
